<header
    role="banner"
    id="header"
    class="global-header fixed"
    [ngClass]="{ compact: compact }"
>
    <div id="skip-to-content">
        <a href="#main-content" (click)="skipToMainContent($event)"
            >Skip to Main Content</a
        >
    </div>

    <!-- Include Utility Header -->
    <div class="utility-header">
        <div class="container">
            <!--TODO: Refactor to oob flex-->
            <div class="group flex-row">
                <div class="social-media-links">
                    <div class="header-cagov-logo">
                        <a
                            href="https://ca.gov"
                            aria-label="Go to California website"
                        >
                            <span class="sr-only">CA.gov</span>
                            <img
                                src="/assets/images/Ca-Gov-Logo-Gold.svg"
                                alt=""
                                aria-hidden="true"
                                class="pos-rel"
                            />
                        </a>
                    </div>
                    <a
                        [routerLink]="['dashboard']"
                        class="ca-gov-icon-home d-none d-sm-block"
                        aria-label="Go to LAS home"
                    >
                        <span class="sr-only">Home</span>
                    </a>
                </div>
                <div class="settings-links">
                    <div class="btn-group" dropdown *ngIf="user">
                        <!--<button class="btn btn-sm btn-primary dropdown-toggle"
                                id="userDropdown"
                                dropdownToggle
                                matRipple>
                          <span class="ca-gov-icon-user-id" aria-hidden="true"></span> {{user.name}}
                        </button>-->
                        <button
                            class="btn btn-sm btn-primary"
                            *ngIf="!user"
                            [matMenuTriggerFor]="loginMenu"
                        >
                            Login
                        </button>
                        <mat-menu #loginMenu="matMenu">
                            <button type="button" (click)="login()">
                                Login using Redirect
                            </button>
                            <!--<button mat-menu-item (click)="loginPopup()">Login using Popup</button>-->
                        </mat-menu>
                        <button
                            class="btn btn sm btn-primary"
                            *ngIf="user"
                            [matMenuTriggerFor]="session"
                        >
                            <ng-container>
                                {{ currentSession?.display ?? "Sessions" }}
                                <span class="ca-gov-icon-caret-down"></span>
                            </ng-container>
                        </button>
                        <button
                            class="btn btn-sm btn-primary"
                            *ngIf="user"
                            [matMenuTriggerFor]="logoutMenu"
                        >
                            <span
                                class="ca-gov-icon-user-id"
                                aria-hidden="true"
                            ></span>
                            {{ user.name }}
                            <span class="ca-gov-icon-caret-down"></span>
                        </button>
                        <mat-menu #logoutMenu="matMenu">
                            <button
                                mat-menu-item
                                *ngIf="isAdmin"
                                [matMenuTriggerFor]="admin"
                            >
                                Admin
                            </button>
                            <button
                                mat-menu-item
                                (click)="openSettings()"
                                aria-controls="notification options"
                            >
                                <mat-icon>settings</mat-icon>
                                <span>Settings</span>
                            </button>
                            <button mat-menu-item (click)="logout()">
                                <mat-icon>logout</mat-icon>
                                <span>Logout</span>
                            </button>
                        </mat-menu>
                        <mat-menu #admin="matMenu">
                            <button
                                mat-menu-item
                                [routerLink]="['admin/users']"
                            >
                                Users
                            </button>
                            <button
                                mat-menu-item
                                [routerLink]="['admin/metadata']"
                            >
                                Metadata
                            </button>
                            <button
                                mat-menu-item
                                [routerLink]="['admin/templates']"
                            >
                                Templates
                            </button>
                        </mat-menu>
                        <mat-menu #session>
                            <las-session></las-session>
                        </mat-menu>

                        <ul
                            *dropdownMenu
                            class="dropdown-menu dropdown-menu-right rounded-0"
                            aria-labelledby="button-basic"
                            role="menu"
                        >
                            <li role="menuitem">
                                <button
                                    class="dropdown-item"
                                    (click)="logout()"
                                >
                                    Log Out
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="!user">
                        <button
                            class="btn btn-sm btn-primary"
                            (click)="login()"
                            matRipple
                        >
                            <span
                                class="ca-gov-icon-user-id"
                                aria-hidden="true"
                            ></span>
                            Log In
                        </button>
                    </div>
                    <las-notifications-toggle
                        *ngIf="user"
                    ></las-notifications-toggle>
                    <!--                    <button class="btn btn-sm btn-primary"-->
                    <!--                            data-toggle="collapse"-->
                    <!--                            data-target="#siteSettings"-->
                    <!--                            aria-expanded="false"-->
                    <!--                            aria-controls="siteSettings"-->
                    <!--                            role="tab"-->
                    <!--                            aria-selected="false"-->
                    <!--                            matTooltip="Settings"-->
                    <!--                            [routerLink]="['settings']"-->
                    <!--                            matRipple>-->
                    <!--                        <span class="ca-gov-icon-gear" aria-hidden="true"></span>-->
                    <!--                        <ng-container *ngIf="!bpState.matches">&nbsp;Settings</ng-container>-->
                    <!--                    </button>-->
                </div>
            </div>
        </div>
    </div>
    <div>
        <!-- Include Branding and Controls -->
        <!-- header branding -->
        <div class="branding">
            <div class="header-organization-banner">
                <a
                    [routerLink]="['dashboard']"
                    matRipple
                    aria-label="Go to LAS dashboard"
                >
                    <div class="logo-assets">
                        <!--                        <img src="/assets/images/template-logo.png" class="logo-img" alt="State Template Logo">-->
                        <h1 class="app-title mobile-control">
                            {{ shortName }}
                        </h1>
                    </div>
                </a>
            </div>
        </div>
        <!-- Include Mobile Controls -->
        <!-- mobile navigation controls -->
        <div class="mobile-controls">
            <span
                class="mobile-control-group mobile-header-icons nav-header-buttons"
            >
                <!-- Add more mobile controls here. These will be on the right side of the mobile page header section -->
                <button
                    class="mobile-control toggle-search"
                    (click)="toggleSearch($event)"
                    *ngIf="showSearchControl"
                    matRipple
                >
                    <span
                        class="ca-gov-icon-search hidden-print"
                        aria-hidden="true"
                    ></span>
                    <span class="sr-only">Search</span>
                </button>
                <button
                    id="nav-icon3"
                    class="mobile-control toggle-menu"
                    (click)="toggleMobileControls()"
                    [attr.aria-expanded]="navOpen"
                    aria-controls="navigation"
                    matRipple
                >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span class="sr-only">Menu</span>
                </button>
            </span>
        </div>
    </div>
    <div class="navigation-search">
        <nav
            id="navigation"
            class="main-navigation megadropdown auto-highlight collapse"
            [ngClass]="{
                show: navOpen || !mobileQuery.matches,
                collapsed: !navOpen,
                'mobile-nav': mobileQuery.matches,
            }"
            role="navigation"
        >
            <ul
                id="nav_list"
                class="top-level-nav nav-menu js-nav-menu"
                *ngIf="(authed$ | async) && loginDisplay && navItems"
            >
                <ng-container *ngFor="let item of navItems">
                    <li
                        class="nav-item"
                        *ngIf="inRole(item.roles)"
                        routerLinkActive="active"
                    >
                        <a
                            *ngIf="!item.routerLink && !item.click"
                            href="#"
                            class="first-level-link has-sub"
                            [ngClass]="item.open ? 'open' : ''"
                            [attr.id]="item.id"
                            role="button"
                            [attr.aria-controls]="'accessible-menu-' + item.id"
                            [attr.aria-expanded]="item.open"
                            tabindex="0"
                            (click)="openNavItem(item); $event.preventDefault()"
                            (keyup.enter)="openNavItem(item)"
                            matRipple
                            mat-icon-button
                        >
                            <span
                                class="ca-gov-icon"
                                *ngIf="
                                    item.icon &&
                                    (!compact || mobileQuery.matches)
                                "
                            >
                                <mat-icon
                                    class="ca-gov-icon"
                                    *ngIf="item.icon"
                                    >{{ item.icon }}</mat-icon
                                >
                            </span>
                            <img
                                class="image-icon rounded-50x m-b-md"
                                alt=""
                                [ngSrc]="item.image"
                                *ngIf="item.image"
                            />
                            &nbsp; {{ item.title }}
                            <div
                                class="ca-gov-icon-caret-right rotate"
                                aria-hidden="true"
                                *ngIf="mobileQuery.matches"
                            ></div>
                            <span
                                class="ca-gov-icon-triangle-down carrot"
                                aria-hidden="true"
                                *ngIf="!mobileQuery.matches"
                            ></span>
                        </a>
                        <a
                            *ngIf="item.click"
                            href="#"
                            class="first-level-link"
                            [ngClass]="item.open ? 'open' : ''"
                            [attr.id]="item.id"
                            role="button"
                            [attr.aria-controls]="'accessible-menu-' + item.id"
                            [attr.aria-expanded]="item.open"
                            tabindex="0"
                            (click)="
                                item.click($event, this);
                                $event.preventDefault()
                            "
                            (keyup.enter)="item.click($event, this)"
                            matRipple
                        >
                            <span
                                class="ca-gov-icon"
                                *ngIf="
                                    item.icon &&
                                    (!compact || mobileQuery.matches)
                                "
                            >
                                <mat-icon
                                    class="ca-gov-icon"
                                    *ngIf="item.icon"
                                    >{{ item.icon }}</mat-icon
                                >
                            </span>
                            <img
                                class="image-icon rounded-50x m-b-md"
                                alt=""
                                *ngIf="item.image"
                                [src]="item.image"
                            />
                            &nbsp; {{ item.title }}
                        </a>
                        <a
                            *ngIf="item.routerLink"
                            class="first-level-link"
                            [ngClass]="item.open ? 'open' : ''"
                            [attr.id]="item.id"
                            role="button"
                            [attr.aria-controls]="'accessible-menu-' + item.id"
                            [attr.aria-expanded]="item.open"
                            tabindex="0"
                            [routerLink]="item.routerLink"
                            matRipple
                        >
                            <span
                                class="ca-gov-icon"
                                *ngIf="
                                    item.icon &&
                                    (!compact || mobileQuery.matches)
                                "
                            >
                                <mat-icon
                                    class="ca-gov-icon"
                                    *ngIf="item.icon"
                                    >{{ item.icon }}</mat-icon
                                >
                            </span>
                            <img
                                class="image-icon rounded-50x m-b-md"
                                alt=""
                                *ngIf="item.image"
                                [ngSrc]="item.image"
                            />
                            &nbsp; {{ item.title }}
                        </a>
                        <div
                            class="sub-nav with-few-items"
                            [ngClass]="item.open ? 'open' : ''"
                            role="region"
                            [attr.aria-expanded]="item.open"
                            aria-hidden="false"
                        >
                            <!-- TODO: Refactor to oob flex -->
                            <div
                                class="second-level-nav flex"
                                *ngIf="item.subItems"
                            >
                                <ng-container
                                    *ngFor="let subItem of item.subItems"
                                >
                                    <ng-container *ngIf="inRole(subItem.roles)">
                                        <a
                                            *ngIf="subItem.url"
                                            [attr.href]="subItem.url"
                                            class="second-level-link"
                                            matRipple
                                        >
                                            <span
                                                class="font-size-40"
                                                *ngIf="subItem.icon"
                                                [ngClass]="subItem.icon"
                                            ></span>
                                            <img
                                                class="image-icon rounded-50x m-b-md"
                                                alt=""
                                                *ngIf="subItem.image"
                                                [ngSrc]="subItem.image"
                                            />
                                            &nbsp;
                                            <p class="h3 sub-nav-link">
                                                {{ subItem.title }}
                                            </p>
                                            <p class="link-description">
                                                {{ subItem.description }}
                                            </p>
                                        </a>
                                        <a
                                            class="second-level-link"
                                            *ngIf="subItem.routerLink"
                                            [routerLink]="subItem.routerLink"
                                            matRipple
                                        >
                                            <span
                                                class="font-size-40"
                                                *ngIf="subItem.icon"
                                                [ngClass]="subItem.icon"
                                            ></span>
                                            <img
                                                class="image-icon rounded-50x m-b-md"
                                                alt=""
                                                *ngIf="subItem.image"
                                                [ngSrc]="subItem.image"
                                            />
                                            &nbsp;
                                            <p class="h3 sub-nav-link">
                                                {{ subItem.title }}
                                            </p>
                                            <p class="link-description">
                                                {{ subItem.description }}
                                            </p>
                                        </a>
                                        <a
                                            class="second-level-link"
                                            *ngIf="subItem.click"
                                            (click)="
                                                subItem.click($event, this);
                                                $event.preventDefault()
                                            "
                                            (keyup.enter)="
                                                subItem.click($event, this)
                                            "
                                            href="#"
                                            matRipple
                                        >
                                            <span
                                                class="font-size-40"
                                                *ngIf="subItem.icon"
                                                [ngClass]="subItem.icon"
                                            ></span>
                                            <img
                                                class="image-icon rounded-50x m-b-md"
                                                alt=""
                                                *ngIf="subItem.image"
                                                [src]="subItem.image"
                                            />
                                            &nbsp;
                                            <p class="h3 sub-nav-link">
                                                {{ subItem.title }}
                                            </p>
                                            <p class="link-description">
                                                {{ subItem.description }}
                                            </p>
                                        </a>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <div
                                class="second-level-nav flex with-border"
                                *ngIf="item.borderItems"
                            >
                                <ng-container
                                    *ngFor="let subItem of item.borderItems"
                                >
                                    <ng-container *ngIf="inRole(subItem.roles)">
                                        <a
                                            class="second-level-link"
                                            *ngIf="subItem.url"
                                            [attr.href]="subItem.url"
                                            matRipple
                                        >
                                            <span
                                                *ngIf="subItem.icon"
                                                [ngClass]="subItem.icon"
                                            ></span>
                                            <img
                                                class="image-icon rounded-50x m-b-md"
                                                alt=""
                                                *ngIf="subItem.image"
                                                [ngSrc]="subItem.image"
                                            />
                                            &nbsp; {{ subItem.title }}
                                            <p class="link-description">
                                                {{ subItem.description }}
                                            </p>
                                        </a>
                                        <a
                                            class="second-level-link"
                                            *ngIf="subItem.routerLink"
                                            [routerLink]="subItem.routerLink"
                                            matRipple
                                        >
                                            <span
                                                *ngIf="subItem.icon"
                                                [ngClass]="subItem.icon"
                                            ></span>
                                            <img
                                                class="image-icon rounded-50x m-b-md"
                                                alt=""
                                                *ngIf="subItem.image"
                                                [ngSrc]="subItem.image"
                                            />
                                            &nbsp; {{ subItem.title }}
                                            <p class="link-description">
                                                {{ subItem.description }}
                                            </p>
                                        </a>
                                        <a
                                            class="second-level-link"
                                            *ngIf="subItem.click"
                                            (click)="
                                                subItem.click($event, this);
                                                $event.preventDefault()
                                            "
                                            (keyup.enter)="
                                                subItem.click($event, this)
                                            "
                                            href="#"
                                            matRipple
                                        >
                                            <span
                                                class="font-size-40"
                                                *ngIf="subItem.icon"
                                                [ngClass]="subItem.icon"
                                            ></span>
                                            <img
                                                class="image-icon rounded-50x m-b-md"
                                                alt=""
                                                *ngIf="subItem.image"
                                                [ngSrc]="subItem.image"
                                            />
                                            &nbsp;
                                            <p class="h3 sub-nav-link">
                                                {{ subItem.title }}
                                            </p>
                                            <p class="link-description">
                                                {{ subItem.description }}
                                            </p>
                                        </a>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </li>
                </ng-container>
                <li class="nav-item">
                    <a
                        class="first-level-link"
                        id="reports"
                        role="button"
                        tabindex="0"
                        [routerLink]="['reports']"
                        matRipple
                    >
                        <span class="ca-gov-icon">
                            <mat-icon class="ca-gov-icon">gavel</mat-icon>
                        </span>
                        Reports
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="first-level-link"
                        href="#"
                        id="user-assignments-button"
                        role="button"
                        aria-haspopup="dialog"
                        tabindex="0"
                        (click)="openUserAssignments(); $event.preventDefault()"
                        (keyup.enter)="openUserAssignments()"
                        matRipple
                    >
                        <span class="ca-gov-icon">
                            <mat-icon class="ca-gov-icon">assignment</mat-icon>
                        </span>
                        Assignments
                    </a>
                </li>
                <li
                    class="nav-item"
                    id="nav-item-search"
                    *ngIf="showSearchControl"
                >
                    <a
                        href="#"
                        class="first-level-link"
                        role="button"
                        aria-controls="search"
                        (click)="toggleSearch($event); $event.preventDefault()"
                        matRipple
                    >
                        <span
                            class="ca-gov-icon-search"
                            aria-hidden="true"
                        ></span>
                        &nbsp;Search
                    </a>
                </li>
            </ul>
        </nav>
        <div
            id="head-search"
            class="search-container"
            [ngClass]="{ active: searchOpen }"
        >
            <!-- Include Search -->
            <div class="container">
                <div class="row">
                    <form
                        id="search"
                        class="pos-rel"
                        (keydown.enter)="$event.preventDefault()"
                    >
                        <span class="sr-only" id="SearchInput"
                            >Legislative Bill Search</span
                        >
                        <input
                            type="text"
                            #billSearch
                            id="billSearch"
                            name="billSearch"
                            aria-labelledby="SearchInput"
                            placeholder="Search Bills"
                            class="height-50 border-0 p-x-sm w-100 search-textfield"
                            (keyup.enter)="
                                openSearchResultsDialog(billSearch.value)
                            "
                            [disabled]="!searchOpen"
                        />
                        <button
                            type="submit"
                            class="gsc-search-button width-50 height-50 border-0 bg-transparent"
                            (click)="openSearchResultsDialog(billSearch.value)"
                            aria-label="Submit Search"
                            [disabled]="!searchOpen"
                        >
                            <span
                                class="ca-gov-icon-search font-size-30 white"
                                aria-hidden="true"
                            ></span>
                            <span class="sr-only">Submit</span>
                        </button>
                        <button
                            class="gsc-clear-button width-50 height-50 border-0 bg-transparent pos-rel"
                            type="reset"
                            (click)="closeSearch()"
                            [disabled]="!searchOpen"
                        >
                            <span
                                class="ca-gov-icon-close-mark font-size-30 white"
                                aria-hidden="true"
                            ></span>
                            <span class="sr-only">Close Search</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="header-decoration"></div>
</header>
